import React, { useState } from "react";
import { Button, Card, CardBody, Col, Row } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTasks } from "@fortawesome/free-solid-svg-icons";
import FalconCardHeader from "../common/FalconCardHeader";
import useOnboardingProgress from "../../helpers/hooks/useOnboardingProgress";
import handleErrorMessage from "../../helpers/errors/handleErrorMessage";
import { Toast } from "../UI/toast/Toast";

/**
 * HO-HU-36: interruptor para volver a mostrar (u ocultar) la guia de primeros
 * pasos de este condominio.
 *
 * Existe porque "Ocultar guia" se guarda en la base y es permanente: sin este
 * interruptor, quien la ocultaba una vez --incluso por error-- se quedaba sin
 * guia sin ninguna forma de recuperarla desde la aplicacion.
 *
 * Va en su propia tarjeta, fuera del formulario de configuracion, para no
 * mezclarse con el `edited`/`handleSubmitData` de esa pantalla: es una
 * preferencia que se guarda sola al tocarla, no un campo del formulario.
 */
const OnboardingVisibilityCard = () => {
  const { enabled, isLoading, error, isHidden, completed, total, setHidden } =
    useOnboardingProgress();
  const [saving, setSaving] = useState(false);

  if (!enabled || isLoading || error) {
    return null;
  }

  const handleToggle = async () => {
    setSaving(true);
    try {
      await setHidden(!isHidden);
      Toast.fire({
        type: "success",
        title: isHidden
          ? "La guía de primeros pasos vuelve a estar visible en el Inicio."
          : "La guía de primeros pasos quedó oculta.",
      });
    } catch (requestError) {
      handleErrorMessage(requestError);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Card className="mb-3">
      <FalconCardHeader title="Guía de primeros pasos" />
      <CardBody>
        <Row className="align-items-center">
          <Col>
            <p className="fs--1 mb-1">
              <FontAwesomeIcon icon={faTasks} className="mr-2 text-500" />
              {isHidden
                ? "Está oculta en el Inicio de este condominio."
                : "Se mantiene visible en el Inicio de este condominio hasta que la ocultes manualmente."}
            </p>
            <p className="fs--2 text-600 mb-0">
              Progreso actual: {completed} de {total} pasos.
            </p>
          </Col>
          <Col xs={12} md="auto" className="mt-3 mt-md-0">
            <Button
              type="button"
              color={isHidden ? "primary" : "falcon-default"}
              size="sm"
              disabled={saving}
              onClick={handleToggle}
            >
              {saving
                ? "Guardando..."
                : isHidden
                  ? "Volver a mostrar la guía"
                  : "Ocultar la guía"}
            </Button>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};

export default OnboardingVisibilityCard;
